import React ,{useState,useRef} from 'react';
import { useHistory } from "react-router-dom";
import "./AppHeading.css"
import { GlobalContext } from '../../contexts/GlobalContext';
import { authenticationService, surveyService } from '../../services';
import MunicipalitySearch from '../MunicipalitySearch';
import Permission from '../Permission';
import Roles from '../Permission/Roles';

const AppHeading = ({title, style, dark, hasLogin, hasLogout,hasSurveyVerificationCounter, ...props}) => {
    const history = useHistory();

	const [unverifiedSupplyAndDemandSurveyCount, setUnverifiedSupplyAndDemandSurveyCount] = useState(null);
    const [unverifiedResidentQuestionnaire, setUnverifiedResidentQuestionnaire] = useState(null);
    const [unverifiedMunicipalityQuestionnaire, setUnverifiedMunicipalityQuestionnaire] = useState(null);
    const handleLogin = () => {
        history.push("/app/login");
    }
  async  function handleLogout() {
        try {
            await authenticationService.logout();
            console.log("Logged out")
          }
          catch(error) {
            console.error('Failed logout:', error);
          }        
          history.go(0)

    }
    async function getUnverifiedSurveys(){
        setUnverifiedSupplyAndDemandSurveyCount(await surveyService.getUnverifiedSurveysCount('supply-demand-not-verified'))
        setUnverifiedResidentQuestionnaire(await surveyService.getUnverifiedSurveysCount('resident-questionnaire-count'))
        setUnverifiedMunicipalityQuestionnaire(await surveyService.getUnverifiedSurveysCount('municipality-questionnaire-count'))      
    }

    React.useEffect(() => {
        let fetchData = async () => {
           await Promise.all([getUnverifiedSurveys()]);
        }
        
        fetchData();
    }, [])

    return (<>
        <div className={`app-heading ${dark && 'dark' || ''}`} {...style}>
            <div className="app-heading__logo">
                {/*<div className={`app-heading__appname ${props.analytics || ''}`}></div> Nacionalna baza biciklističke parkirališne ponude i potražnje*/}
                <div className={`app-heading__appname ${props.report || ''}`}>{title || 'CikloParking'}</div>
                <div className="app-heading__trademark"><a href='https://academica.hr/'>&copy; ACADEMICA</a></div>
               
            </div>
   
           
            {hasLogin && (
                <div className="app-heading__login" onClick={handleLogin}><i className="ri-user-fill"></i></div>
            )}
            {hasLogout && (
                <div className="app-heading__logout" onClick={handleLogout}><i className="ri-user-shared-2-fill"></i></div>
            )}
         {hasSurveyVerificationCounter&&<Permission roles={[Roles.Admin,Roles.Verifikator]}>
         <div className='app-heading__verification-counter'>
                <li>{unverifiedSupplyAndDemandSurveyCount&&unverifiedSupplyAndDemandSurveyCount[0]&&<>{unverifiedSupplyAndDemandSurveyCount[0].count}</>||<>0</>}</li>
                <li>{unverifiedResidentQuestionnaire&&unverifiedResidentQuestionnaire[0]&&<>{unverifiedResidentQuestionnaire[0].count}</>||<>0</>}</li>
                <li>{unverifiedMunicipalityQuestionnaire&&unverifiedMunicipalityQuestionnaire[0]&&<>{unverifiedMunicipalityQuestionnaire[0].count}</>||<>0</>}</li>
                </div>
         </Permission>
         }
        </div>
                   
   </>)
}

export default AppHeading;